<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query'
import { officeTreeQuery_2 } from '@mp/api/sdpShop/CompanyGatewayTempController.ts'
import { computed } from 'vue'

const { width = '100%' } = defineProps<{
  width?: string
}>()

const emits = defineEmits<{
  change: [value: any]
}>()
const modelValue = defineModel<string | undefined>()
const {
  data,
} = useQuery({
  queryKey: ['mch/currentuser/office/tree/query'],
  queryFn: () => officeTreeQuery_2(),
  select: (res) => {
    if (!modelValue.value && res?.data?.officeCode)
      modelValue.value = res?.data?.officeCode // ?默认设置总部
    return res?.data
  },
})

const treeData = computed(() => {
  // const { children = [], ...top } = data.value || {}
  const filterData = data.value || {}
  return [filterData]
})

function handleChange(value: string) {
  emits('change', value)
}

defineExpose({
  reset: () => {
    modelValue.value = data.value?.officeCode
  },
})
</script>

<template>
  <el-tree-select
    v-model="modelValue"
    :data="treeData"
    clearable
    :props="{
      value: 'officeCode',
      label: 'officeName',
      children: 'children',
    }"
    placeholder="请选择商户层级"
    check-strictly
    :render-after-expand="false"
    :style="{ width }"
    @change="handleChange"
  />
</template>
